export const SANDBOX_ONBOARDING_URL = 'https://sandbox.onboarding.gigsafe.com'

export function isSandbox(): boolean {
  return process.env.REACT_APP_ONBOARDING_CLIENT_URL === SANDBOX_ONBOARDING_URL
}

// Above all dashboard z-index layers (FileModal 13000, snackbars 10000, settings 2000–2001).
export const INTERCOM_Z_INDEX = 1000

export function isIntercomDisabled(): boolean {
  try {
    return window.localStorage.getItem('disable_intercom') === 'true'
  } catch {
    return false
  }
}
